<template>
  <div>
    <formula-head :details="details" />
    <formula-base :details="details" />
    <formula-tabs />
  </div>
</template>

<script>
import FormulaHead from './editor/FormulaHead.vue'
import FormulaBase from './editor/FormulaBase.vue'
import FormulaTabs from './editor/FormulaTabs.vue'
import { getRequest } from "@/components/Common/Utils/Utils.js";
import { nhfMixins } from "../untils";
export default {
  mixins: [nhfMixins],
  components: {FormulaHead,FormulaBase,FormulaTabs},
  data(){
    return {
      details: {},
      formulaId: getRequest('id'),
    }
  },
  mounted(){
    this.getDetail()
  },
  methods:{
    async getDetail() {
      this.$http.get('/nhf-app/formulaManage/getFormulaVoDetailById',{params: {formulaId: this.formulaId}}).then(res => {
        if(res && res.data){
          this.details = res.data
        }
      })
    },
  }
}
</script>